import Icon1 from '../../icons/01d.svg?react';
import Icon2 from '../../icons/01n.svg?react';
import Icon3 from '../../icons/02d.svg?react';
import Icon4 from '../../icons/02n.svg?react';
import Icon5 from '../../icons/03d.svg?react';
import Icon6 from '../../icons/03n.svg?react';
import Icon7 from '../../icons/04d.svg?react';
import Icon8 from '../../icons/04n.svg?react';
import Icon9 from '../../icons/09d.svg?react';
import Icon10 from '../../icons/09n.svg?react';
import Icon11 from '../../icons/10d.svg?react';
import Icon12 from '../../icons/10n.svg?react';
import Icon13 from '../../icons/11d.svg?react';
import Icon14 from '../../icons/11n.svg?react';
import Icon15 from '../../icons/13d.svg?react';
import Icon16 from '../../icons/13n.svg?react';

const iconsData: Record<string, any> = {
  '01d': Icon1,
  '01n': Icon2,
  '02d': Icon3,
  '02n': Icon4,
  '03d': Icon5,
  '03n': Icon6,
  '04d': Icon7,
  '04n': Icon8,
  '09d': Icon9,
  '09n': Icon10,
  '10d': Icon11,
  '10n': Icon12,
  '11d': Icon13,
  '11n': Icon14,
  '13d': Icon15,
  '13n': Icon16
};

export function Icon({ name }: { name: string }) {
  const Icon = iconsData[name];

  return <Icon viewBox="4 4 58 58" />;
}
